<template>
  <el-dialog
    :title="title"
    :visible="true"
    :width="width"
    :close-on-click-modal="false"
    @close="onDialogClose"
  >
    <div>{{ content }}</div>
    <div>
      <slot name="body" />
    </div>
    <div slot="footer" class="dialog-footer">
      <div class>
        <BaseElButton v-if="!hideCancel" :loading="cancelBtnLoading" plain @click="onCancelClick">
          {{ cancelBtnString }}
        </BaseElButton>
        <BaseElButton :loading="confirmBtnLoading" :type="btnType" @click="$emit('confirm')">
          {{ btnString || '確認' }}
        </BaseElButton>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'WarningDialog',

  props: {
    title: {
      type: String,
      default: '提示',
    },
    content: {
      type: String,
      default: '',
    },
    show: Boolean,
    width: {
      type: String,
      default: '440px',
    },
    btnString: String,
    cancelBtnString: {
      type: String,
      default: '取消',
    },
    hideCancel: {
      type: Boolean,
      default: false,
    },
    topRightCloseEventName: {
      type: String,
      default: 'close',
      validator: (value) => ['close', 'dismiss'].includes(value),
    },
    cancelEventName: {
      type: String,
      default: 'close',
      validator: (value) => ['close', 'dismiss'].includes(value),
    },

    btnType: {
      type: String,
      default: 'primary',
    },

    confirmBtnLoading: {
      type: Boolean,
      default: false,
    },
    cancelBtnLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['confirm', 'close', 'dismiss'],

  methods: {
    onDialogClose () {
      this.$emit(this.topRightCloseEventName)
    },
    onCancelClick () {
      this.$emit(this.cancelEventName)
    },
  },
}
</script>

<style scoped lang="scss"></style>
